module.exports = __webpack_public_path__ + "img/22.f312ac10.jpg";